export default __webpack_public_path__ + "static/testosterone-box@2x-52193fc3e544bc656b8ee5abf2237ba5.png";